/** 조사만 반환 (단어 없이) */
export function selectParticle(word: string, withBatchim: string, withoutBatchim: string): string {
  if (!word) return withoutBatchim;
  const lastChar = word.charCodeAt(word.length - 1);
  if (lastChar < 0xac00 || lastChar > 0xd7a3) return withoutBatchim;
  return (lastChar - 0xac00) % 28 !== 0 ? withBatchim : withoutBatchim;
}
